export const paramInputMixin = {
  model: {
    prop: "data",
    event: "change",
  },
  props: {
    data: {
      type: Object,
      default: function () {
        return {};
      },
    },
    optional: Boolean,
    title: {
      type: String,
      default: "",
    },
    validator: {
      type: Function,
      default: function validator() {
        if (!this.optional && !this.data.value) {
          return "required";
        }
        return "";
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    error: function () {
      return this.validator();
    },
    showElement: function () {
      return !this.optional || this.data.value;
    },
  },
  mounted: function () {
    this.varName = this.data.varName;
    this.emitData();
  },
  watch: {
    optional: function () {
      this.emitData();
    },
    data: function (newVal) {
      if (newVal.varName === "ignore_interior_background" && newVal.value === false) {
        newVal.showElement = false;
      }
    },
  },
};
